import classNames from "classnames";
import { FC } from "react";

import s from "./Container.module.scss";

interface ContainerProps {
  size?: "xs" | "s" | "m" | "l";
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

export const Container: FC<ContainerProps> = ({ size = "m", children, className, id }) => (
  <div
    className={classNames(s.Container, className, {
      [s.XSmall]: size === "xs",
      [s.Small]: size === "s",
      [s.Large]: size === "l",
    })}
    {...(id && { id })}
  >
    {children}
  </div>
);
